import { render, staticRenderFns } from "./multi-checkbox.vue?vue&type=template&id=4a2dc3b6&"
import script from "./multi-checkbox.vue?vue&type=script&lang=js&"
export * from "./multi-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports